import router from '@/router/index';

export const MicroAppDict: Record<string, string> = {
  'tms': '/microTms',
  'oms': '/microOms',
  'el-data-report': '/microDataReport',
  'lsp': '/microLsp',
  'lsrm': '/microLsrm',
  'ntp': '/microNtp'
};

interface GlobalMicroRouteOptions {
  path: string;
  props?: {
    type?: 'push' | 'replace';
    system?: keyof typeof MicroAppDict;
    baseRoute?: string;
  };
  [key: string]: any; // 兼容其他 router.push 参数如 query, params 等
}

const globalMicroRoute = (options: GlobalMicroRouteOptions = { path: '' }) => {
  const props = options.props || {};
  const { type = 'push', system, baseRoute = '' } = props;

  // 删除 props 字段，避免传给 router
  const { props: _, ...restOptions } = options;

  // ✅ 安全访问 MicroAppDict，避免 undefined 索引
  const targetBase = system && MicroAppDict[system] ? MicroAppDict[system] : baseRoute;
  const newPath = options.path.replace(new RegExp(`^${baseRoute}`), targetBase);

  router[type]({
    ...restOptions,
    path: newPath,
  });
};

// Vue 3 插件定义
export default {
  install(app: any) {
    app.config.globalProperties.$globalMicroRoute = globalMicroRoute;
    // 可选：提供类型推导（需配合 shims-vue.d.ts）
  },
};

// 如果你希望在 setup 中也能用（推荐方式），可额外导出函数
export { globalMicroRoute };